import { PopoverFloating } from '@components/core-ui/PopoverFloating';
import { AdminJobTopActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/AdminJobTopActionButton';
import EllipsisVerticalIcon from '@components/icons/EllipsisVertical.svg';
import { hasVsDeveloperRole } from '@helpers/hasVsDeveloperRole';
import { useAuthContext } from '@providers/AuthProvider';
import { useRef, useState } from 'react';
import { AttachBackupButton } from '../AttachBackupButton';
import { LlmCallsMenuButton } from '../LlmCallsMenuButton';
import { ResetJobButton } from '../ResetJobButton';
import { SuperEnhancementButton } from '../SuperEnhancementButton';
// import { TranscriptAutoFixButton } from '../TranscriptAutoFixButton';
import { TranscriptReviewButton } from '../TranscriptReviewButton';

export const MoreActionsMenu = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { me } = useAuthContext();
  const isVsDeveloper = hasVsDeveloperRole(me?.roles);

  return (
    <div ref={wrapperRef} className="flex">
      <AdminJobTopActionButton
        title="More actions"
        aria-label="More actions"
        aria-haspopup="menu"
        aria-expanded={isOpen}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={() => setIsOpen((open) => !open)}
      >
        <EllipsisVerticalIcon />
      </AdminJobTopActionButton>
      <PopoverFloating
        open={isOpen}
        onClose={() => setIsOpen(false)}
        anchorEl={wrapperRef.current}
        placement="bottom-end"
        offset={4}
        className="min-w-56"
      >
        <ul className="m-0 block list-none px-0 py-1.5" onClick={() => setIsOpen(false)}>
          {isVsDeveloper ? <SuperEnhancementButton /> : null}
          <TranscriptReviewButton />
          {/* <TranscriptAutoFixButton /> */}
          <ResetJobButton />
          <AttachBackupButton />
          <LlmCallsMenuButton />
        </ul>
      </PopoverFloating>
    </div>
  );
};
